import i from './current-profile-picture.container';

export default i;
